import { Component, OnInit, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface GuideLine {
  title: string;
  response: string;
  shown: boolean;
}

interface GuideGroup {
  id: string;
  grouptitle: string;
  shown: boolean;
  guideLines: GuideLine[];
}

@Component({
  selector: 'app-my-guides',
  templateUrl: './my-guides.component.html',
  styleUrls: ['./my-guides.component.scss']
})
export class MyGuidesComponent implements OnInit, OnDestroy {
  guides: GuideGroup[] = [];
  filteredGuides: GuideGroup[] = [];
  loading = true;
  searchQuery = '';
  selectedCategory = '';
  expandedGuides: Set<string> = new Set();
  private destroy$ = new Subject<void>();

  constructor(private afs: AngularFirestore) {}

  ngOnInit() {
    this.getGuides();
  }

  getGuides() {
    this.afs
      .collection('SupportGuides')//, (ref) => ref.where('shown', '==', true)
      .snapshotChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.guides = res.map((e: any) => {
          const data = e.payload.doc.data();
          // Keep guide lines unless explicitly hidden (shown === false)
          const guideLines = Array.isArray(data.guideLines)
            ? data.guideLines.filter((g: any) => g.shown !== false)
            : [];
          return {
            id: e.payload.doc.id,
            ...data,
            guideLines,
          } as GuideGroup;
        });
        this.filteredGuides = [...this.guides];
        this.loading = false;
      });
  }

  onSearch() {
    if (!this.searchQuery || !this.searchQuery.trim()) {
      this.filteredGuides = this.guides.map((group) => ({
        ...group,
        guideLines: [...group.guideLines],
      }));
      this.selectedCategory = '';
      return;
    }

    const query = this.searchQuery.toLowerCase().trim();
    this.filteredGuides = this.guides
      .map((group) => {
        const filteredLines = group.guideLines.filter(
          (line) =>
            line.title.toLowerCase().includes(query) ||
            line.response.toLowerCase().includes(query)
        );
        return { ...group, guideLines: filteredLines };
      })
      .filter((group) => group.guideLines.length > 0);
  }

  clearSearch() {
    this.searchQuery = '';
    this.selectedCategory = '';
    this.onSearch();
  }

  onCategoryClick(category: string) {
    this.selectedCategory = this.selectedCategory === category ? '' : category;
    this.searchQuery = category;
    this.onSearch();
  }

  toggleGuide(guideId: string) {
    if (this.expandedGuides.has(guideId)) {
      this.expandedGuides.delete(guideId);
    } else {
      this.expandedGuides.add(guideId);
    }
  }

  isGuideExpanded(guideId: string): boolean {
    return this.expandedGuides.has(guideId);
  }

  getGuideId(groupId: string, guideIndex: number): string {
    return `${groupId}-${guideIndex}`;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
